<svelte:head>
	<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.12.0/dist/katex.css" integrity="sha384-qCEsSYDSH0x5I45nNW4oXemORUZnYFtPy/FqB/OjqxabTMW5HVaaH9USK4fN3goV" crossorigin="anonymous">
</svelte:head>

<script lang="ts">
	import katex from 'katex';
	export let math:string;
	export let displayMode = false;
	export let noLineBreak = false;
	let htmlString:string;
	$: htmlString = 
		noLineBreak? katex.renderToString(String(math), {throwOnError: false, displayMode: displayMode})
			: katex.renderToString("{"+String(math)+"}", {throwOnError: false, displayMode: displayMode});
</script>

<span>{@html htmlString}</span>
